// 走渠道销售，在前端不展示价格显示的商品类型
const VB_RELATED = [31, 620, 621, 622, 623, 624, 625, 626];
const CLOUD_RELATED = [572]; // 中国地区云服务不进行销售，但展示价格套餐信息

const isNeedHidePriceProduct = (productId, countryCode) => {
  return (
    (VB_RELATED.includes(productId) && ['CN', 'JP'].includes(countryCode)) ||
    (CLOUD_RELATED.includes(productId) && ['CN'].includes(countryCode))
  );
};

module.exports = {
  VB_RELATED,
  isNeedHidePriceProduct,
};
